const translations = {
    grounded: 'Grounded'
};

export default translations;
